import required from 'utils/required';

import { UPDATE_TITLE } from 'shared/actions/PageDataActions';

const initialState = {
  title: '',
};

export default function pageDataReducer(state = initialState, action) {
  if (action.type === UPDATE_TITLE) {
    const { title = required('title') } = action;
    return { title };
  }
  return state;
}
